export default function LoadingScreen() {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <div className="text-center">
          <div className="flex justify-center items-center mb-5 h-full">
            <img
              src="/images/logo.png"
              alt="Loading..."
              className="w-16 h-16 animate-quarter-spin"
            />
          </div>
          <p className="text-xl font-medium font-nunito text-gray-600 p-4">
            matly skal lige vækkes... ☕ der kan godt gå op til et minut eller to 🫩
          </p>
        </div>
      </div>
    );
  }